<template>
            <div v-bind="$attrs">
                <img :src="props.src"
                :alt="props.alt"
                role="button"
                @click="zoom=true"
                v-bind="$attrs"
                height="300px"
                class="object-contain aspect-auto hover:bg-gray-500/30 outline-red-500 transition-all hover:rounded-sm hover:outline outline-2 h-full w-auto"/>
                <p v-if="props.credit"
                class=" text-xs text-red-600 hover:underline italic w-full text-right bold">
                <a :href="props.pagina" target="_blank"><font-awesome-icon icon="fa-solid fa-camera" class="text-black/50"/>{{'  '+props.credit}}</a>
                    </p>
            </div>
   
    <teleport to="body">
      <Transition name="fadein">
         <div v-if="zoom" class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[9999]" @click.self="zoom=false">
    
        <div class="max-w-[90vw] max-h-[90vh] p-4 md:p-8 flex flex-col items-center justify-center">
              <!-- responsive image: fill width up to container, keep intrinsic ratio and never exceed container height -->
              <img
               :src="props.src"
              :alt="props.alt"
                class="w-full h-auto min-h-[300px] max-h-[90vh] object-contain"
              />
               <p v-if="props.credit"
                     class=" text-base text-white hover:underline italic w-full text-right bold">
                     <a :href="props.pagina" target="_blank"><font-awesome-icon icon="fa-solid fa-camera" class="text-white/50"/>{{' '}}Autoria: <strong>{{props.credit}}{{' '}}<font-awesome-icon :icon="['fas', 'arrow-up-right-from-square']"/></strong></a>
                         </p>
           </div>
          <button class="absolute top-4 right-4 text-white text-3xl font-bold hover:bg-white/30 aspect-square px-2" @click="zoom=false">&times;</button>
        </div>
      </Transition>
    </teleport>
</template>


<script setup>
import {defineProps,ref} from 'vue'
const props=defineProps({
    src:{
        type:String,
        required:true
    },
    alt:{
        type:String,
        required:false,
        default:'Imatge'
    },
    credit:{
        type:String,
        required:false,
    },
    pagina:{
        type:String,
        required:false,
    }
})
const zoom=ref(false)


</script>


<style>

.fadein-enter-active, .fadein-leave-active{
    transition: opacity 0.25s ease;
}


.fadein-enter-from, .fadein-leave-to{
    opacity:0
}

.fadein-enter-to, .fadein-leave-from{
    opacity:1
}


</style>